import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-20 px-4 bg-[#0d0d14] relative border-t border-white/5" data-id="element-110">
      <div className="max-w-4xl mx-auto text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-113">
            Have you been denied credit recently and told you{' '}
            <span className="text-red-500" data-id="element-114">"just had to wait"?</span>
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-6" data-id="element-115">
            Or worse... did your score drop overnight even though you always pay
            on time?
          </p>

          <div className="w-24 h-1 bg-gold mx-auto mb-8 rounded-full" data-id="element-116"></div>

          <p className="text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-117">
            <strong className="text-white" data-id="element-118">It's not your fault.</strong> In
            2026, the system changed the rules in secret, and 90% of people are
            playing a game they can't win.{' '}
            <span className="text-gold font-semibold" data-id="element-119">Until today.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}